import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import { default as React } from 'react';
import { Pie } from 'react-chartjs-2';
import { connect } from 'react-redux';
import * as Score from "utils/Score";
import TitleBox from "views/Shared/TitleBox";
import { ratingBuckets, focusSelection, DistributionBar, Meter, deltaText, MONO } from "./ReportViz";
import pdf from "utils/pdfKit";
import { downloadXlsx } from "utils/xlsx";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button"
import commonStyle from "assets/jss/common/common"
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import uuid from 'uuidv4';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { t } from 'i18next';
import { withTranslation } from 'react-i18next';
import Toast from 'views/Toast/Toast';
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-normal.js')
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-bold.js')

const report_types = [
    {
        label: t('Analytical'),
        value: "Analytical"
    },
    {
        label: t('Summary'),
        value: "Summary"
    },
    {
        label: t('Text reports'),
        value: "Textreports"
    },
    {
        label: t('Comparation'),
        value: "Comparation"
    }
];
const styles = {
    ...commonStyle,
    rating_record: {
        border: '1px solid lightgray'
    },
    table: {
        border: '1px solid lightgray',
        width: '100%',
        borderCollapse: 'collapse'
    },
    th: {
        textAlign: 'left',
        border: '1px solid lightgray',
    },
    td: {
        textAlign: 'left',
        border: '1px solid lightgray',
    },
    borderLineRoot: {
        height: 10,
    },
    borderLineBar: {
        height: 10,
    }
};
class Analytical extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab_index: 0,
            compare: false,
            filterData: this.props.filterData,
            surveyQuestion: this.props.surveyQuestion,
            surveyResponses: this.props.surveyResponses,
            surveyMain: this.props.surveyMain,
            reportData: null,
            reportData2: null
        }
    }

    componentDidMount() {
        this.props.onRef(this)
        this.initData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.time !== this.props.time) {
            this.initData()
        }
    }

    initData = () => {
        const { filterData, surveyQuestion, surveyResponses, surveyResponses2, surveyMain } = this.props
        const data = this.calculateData(surveyQuestion, surveyResponses)
        const data2 = surveyResponses2 ? this.calculateData(surveyQuestion, surveyResponses2) : null
        this.setState({

            filterData: filterData,
            surveyQuestion: surveyQuestion,
            surveyResponses: surveyResponses,
            surveyMain: surveyMain,
            reportData: data,
            reportData2: data2
        })
    }

    calculateData = (filterQuestion, filterResponses) => {
        let reportSections = [];
        let surveyScore = 0
        let totalResult = null
        if (filterQuestion.sections.length > 0) {

            let countSectionScore = 0
            filterQuestion.sections.map((section) => {
                let reportQuestions = []
                let sectionScore = 0
                if (section.questions.length > 0) {
                    let countQuestionScore = 0
                    section.questions.map((q) => {
                        if (Score.VALUETYPE !== q.question.type) return null;
                        const reportOfQuestion = Score.getReportOfQuestion(q, filterResponses);
                        reportOfQuestion.q = q;
                        reportQuestions.push(reportOfQuestion)
                        if (reportOfQuestion.questionScore > 0) {
                            countQuestionScore++;
                            sectionScore += reportOfQuestion.questionScore
                        }
                    })
                    sectionScore = countQuestionScore > 0 ? (sectionScore / countQuestionScore) : 0
                }
                const reportsForSection = {
                    sectionTitle: section.sectionTitle,
                    reportQuestions,
                    sectionScore
                }
                reportSections.push(reportsForSection)
                if (reportsForSection.sectionScore > 0) {
                    countSectionScore++
                    surveyScore += reportsForSection.sectionScore
                }
            })
            totalResult = {
                reportSections: reportSections,
                surveyScore: countSectionScore > 0 ? (surveyScore / countSectionScore) : 0
            }
        }
        console.info('total result ===>', totalResult)
        return totalResult
    }
    // widest rating scale across the whole report (overall-score denominator)
    overallScale = (reportData) => {
        let sc = 5
        reportData.reportSections.forEach(s => { const m = this.sectionScale(s); if (m > sc) sc = m })
        return sc
    }

    // widest rating scale among a section's questions (score denominator)
    sectionScale = (section) => {
        let sc = 5
        section.reportQuestions.forEach(rq => {
            if (rq.q && rq.q.question && rq.q.question.type === 'radio') {
                const mv = ratingBuckets(rq.q, rq.reports).maxV
                if (mv > sc) sc = mv
            }
        })
        return sc
    }

    // Focus the report on the filter-selected section (and question) — show ONLY that, so the
    // user never has to scroll to a section buried deep in the survey. Nothing selected → all
    // sections, unchanged. focusSelection also filters a section's questions to the chosen one.
    orderedSections = (reportSections) => {
        return focusSelection(reportSections, this.props.surveyQuestion, this.props.filterData).sections
    }

    // Questions are already narrowed by focusSelection when a question is chosen; pass through.
    orderedQuestions = (section) => section.reportQuestions

    isSelectedSection = (section) => {
        const selTitle = this.props.filterData.section ? this.props.filterData.section.label : null
        return selTitle && section.sectionTitle === selTitle
    }

    // Banner shown when the report is focused on a filter-selected section/question.
    renderFocusBanner = () => {
        const fd = this.props.filterData
        if (!fd || !fd.section) return null
        const secT = fd.section.label
        const qT = fd.question ? fd.question.label : null
        return <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', background: '#eef7f1', border: '1px solid #cfe6d7', borderRadius: 10, padding: '9px 14px', margin: '0 0 16px', fontSize: 13, color: '#2f6b4f' }}>
            <span>🔎</span>
            <span><b>{t('Focused view')}:</b> {secT}{qT ? ' › ' + qT : ''} — {t('showing only your filtered selection')}.</span>
            <span style={{ color: '#8a988f' }}>{t('Clear the section filter to see all sections.')}</span>
        </div>
    }

    // Section averages — the meeting view. Single period, or period A/B + Δ when comparing.
    renderSectionAverages = () => {
        const { reportData, reportData2, compare } = this.state
        const hasP2 = !!this.props.surveyResponses2
        const doCompare = compare && hasP2 && reportData2
        const sections = this.orderedSections(reportData.reportSections).filter(s => s.sectionScore > 0)
        const b2 = {}
        if (reportData2) reportData2.reportSections.forEach(s => { b2[s.sectionTitle] = s.sectionScore })

        const rowStyle = { display: 'grid', gridTemplateColumns: '190px 1fr auto', gap: 14, alignItems: 'center', padding: '11px 6px', borderBottom: '1px solid #eef2f0' }
        const nameStyle = { fontSize: 14, fontWeight: 600 }
        const valStyle = { fontFamily: MONO, fontWeight: 700, fontSize: 14, textAlign: 'right', minWidth: 96 }

        return <div>
            {doCompare && <div style={{ display: 'flex', gap: 14, fontSize: 12, color: '#5d6d66', marginBottom: 10 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><i style={{ width: 11, height: 11, borderRadius: 3, background: '#2f9e44' }} />{t('Period 1')} (A)</span>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><i style={{ width: 11, height: 11, borderRadius: 3, background: '#3b6fd4' }} />{t('Period 2')} (B)</span>
                <span style={{ color: '#8a988f' }}>Δ = A − B</span>
            </div>}
            {sections.map(section => {
                const sc = this.sectionScale(section)
                const A = section.sectionScore
                const B = b2[section.sectionTitle] || 0
                const sel = this.isSelectedSection(section)
                const rs = sel ? Object.assign({}, rowStyle, { background: '#f2f9f4', borderLeft: '3px solid #2f9e44', paddingLeft: 10, borderRadius: 6 }) : rowStyle
                return <div style={rs} key={uuid()}>
                    <div style={nameStyle}>{section.sectionTitle}{sel ? <span style={{ marginLeft: 6, fontSize: 10.5, fontWeight: 800, color: '#2f8a45' }}>★</span> : null}</div>
                    {!doCompare
                        ? <Meter value={A} max={sc} />
                        : <div style={{ display: 'grid', gridTemplateRows: '1fr 1fr', gap: 3 }}>
                            <div style={{ height: 9, borderRadius: 99, background: '#e2e8e4', overflow: 'hidden' }}><div style={{ width: (A / sc * 100) + '%', height: '100%', background: '#2f9e44', borderRadius: 99 }} /></div>
                            <div style={{ height: 9, borderRadius: 99, background: '#e2e8e4', overflow: 'hidden' }}><div style={{ width: (B / sc * 100) + '%', height: '100%', background: '#3b6fd4', borderRadius: 99 }} /></div>
                        </div>}
                    <div style={valStyle}>
                        {A.toFixed(2)}<span style={{ color: '#8a988f' }}> / {doCompare ? B.toFixed(2) : sc}</span>
                        {doCompare ? deltaText(A, B) : null}
                    </div>
                </div>
            })}
        </div>
    }
    addDocText(doc, text, x, y) {
        const docWidth = doc.internal.pageSize.getWidth();

        var line = y // Line height to start text at
        var lineHeight = 4
        var leftMargin = x
        var wrapWidth = docWidth - 2 * x

        var splitText = doc.splitTextToSize(text, wrapWidth)
        for (var i = 0, length = splitText.length; i < length; i++) {
            // loop thru each line and increase
            doc.text(splitText[i], leftMargin, line)
            line = lineHeight + line
        }
        return line
    }

    generatePdf = (fileName) => {
        const doc = new jsPDF();
        const W = doc.internal.pageSize.getWidth();
        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const { reportData } = this.state
        if (!reportData) { Toast(400, 'Error to generate PDF report'); return; }

        // Compare = the Summary's own toggle + a 2nd period supplied by the page.
        const doCompare = this.state.compare && !!this.props.surveyResponses2
        const summaryData = this.calculateData(surveyQuestion, surveyResponses)
        const summaryData2 = doCompare ? this.calculateData(surveyQuestion, this.props.surveyResponses2) : null
        const scale = this.overallScale(reportData) || 5

        // Branded header band with title + period(s) + response count.
        const period1 = moment(filterData.from1).format('LL') + ' – ' + moment(filterData.to1).format('LL')
        const period2 = moment(filterData.from2).format('LL') + ' – ' + moment(filterData.to2).format('LL')
        const subtitle = period1 + (doCompare ? '  ·  vs ' + period2 : '') + '   ·   ' + surveyResponses.length + ' ' + t('Answers')
        let y = pdf.header(doc, { title: surveyMain.title, subtitle, right: t('Summary') })

        // Active filters as a light caption (only when something is filtered).
        const flt = []
        if (filterData.group.length) flt.push(t('Emails Group') + ': ' + filterData.group.map(a => a.label).join(', '))
        if (filterData.section) flt.push(t('Section') + ': ' + filterData.section.label)
        if (filterData.question) flt.push(t('Question') + ': ' + filterData.question.label)
        if (filterData.answer.length) flt.push(t('Answers') + ': ' + filterData.answer.map(a => a.label).join(', '))
        if (flt.length) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8); doc.setTextColor(pdf.FAINT[0], pdf.FAINT[1], pdf.FAINT[2]);
            doc.text(flt.join('    |    '), 12, y, { maxWidth: W - 24 }); y += 6;
        }

        // Focus on the filter-selected section/question, exactly like the on-screen report.
        const focus = focusSelection(summaryData.reportSections, surveyQuestion, filterData)
        const focusSecs2 = doCompare ? focus.indices.map(i => summaryData2.reportSections[i]) : null
        if (focus.focused) {
            doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(8); doc.setTextColor(pdf.GREEN[0], pdf.GREEN[1], pdf.GREEN[2]);
            doc.text('🔎 ' + t('Focused view') + ': ' + focus.sectionTitle + (focus.questionTitle ? ' › ' + focus.questionTitle : ''), 12, y, { maxWidth: W - 24 }); y += 6;
        }

        // Section averages (A / B / Δ when comparing), scores colour-coded.
        let head, body;
        if (doCompare) {
            head = [[t('Section Average with Rating'), 'A', 'B', 'Δ']]
            body = []
            focus.sections.forEach((s, i) => {
                if (s.sectionScore <= 0) return
                const s2 = focusSecs2[i]
                const a = s.sectionScore, b = s2 ? s2.sectionScore : 0, d = a - b
                body.push([s.sectionTitle,
                    { content: a.toFixed(2), styles: { textColor: pdf.scoreColor(a, scale), fontStyle: 'bold', halign: 'right' } },
                    { content: b.toFixed(2), styles: { textColor: pdf.scoreColor(b, scale), fontStyle: 'bold', halign: 'right' } },
                    { content: (d >= 0 ? '+' : '') + d.toFixed(2), styles: { textColor: pdf.deltaColor(d), fontStyle: 'bold', halign: 'right' } }])
            })
        } else {
            head = [[t('Section Average with Rating'), t('Score')]]
            body = []
            focus.sections.forEach((s) => {
                if (s.sectionScore <= 0) return
                body.push([s.sectionTitle,
                    { content: s.sectionScore.toFixed(2), styles: { textColor: pdf.scoreColor(s.sectionScore, scale), fontStyle: 'bold', halign: 'right' } }])
            })
        }
        doc.autoTable(pdf.modernOptions({ startY: y, head, body }))
        y = doc.previousAutoTable.finalY + 8

        // Questions-with-rating matrix (single period, as on screen). Score cells colour-coded.
        const labels = []
        focus.sections.forEach(s => s.reportQuestions.forEach(q => q.reports.forEach(r => { if (labels.indexOf(r.answerLabel) < 0) labels.push(r.answerLabel) })))
        const mhead = [[t('Question')].concat(labels).concat([t('Score')])]
        const mbody = []
        focus.sections.forEach(s => {
            if (s.sectionScore <= 0) return
            mbody.push([
                { content: s.sectionTitle, colSpan: labels.length + 1, styles: { fillColor: pdf.SEC_FILL, textColor: pdf.GREEN, fontStyle: 'bold' } },
                { content: s.sectionScore.toFixed(2), styles: { textColor: pdf.scoreColor(s.sectionScore, scale), fontStyle: 'bold', halign: 'right' } },
            ])
            s.reportQuestions.forEach(q => {
                const row = [q.questionTitle]
                labels.forEach(l => { const b = q.reports.filter(x => x.answerLabel === l)[0]; row.push(b ? `${b.count} (${b.percent.toFixed(0)}%)` : '—') })
                row.push({ content: q.questionScore.toFixed(2), styles: { textColor: pdf.scoreColor(q.questionScore, scale), fontStyle: 'bold', halign: 'right' } })
                mbody.push(row)
            })
        })
        const colStyles = { 0: { cellWidth: (W - 24) / 3.1, halign: 'left' } }
        for (let i = 1; i <= labels.length; i++) colStyles[i] = { halign: 'right' }
        colStyles[labels.length + 1] = { halign: 'right' }
        doc.autoTable(pdf.modernOptions({
            startY: y, head: mhead, body: mbody,
            styles: { font: 'DejaVuSans', fontSize: 7.5, cellPadding: 2.5, textColor: pdf.INK, lineWidth: 0, overflow: 'linebreak' },
            columnStyles: colStyles,
        }))

        pdf.footer(doc)
        doc.save(fileName)
    }

    generateCSV = () => {
        var rows = [];

        const { filterData, surveyQuestion, surveyResponses, surveyMain } = this.props
        const { reportData } = this.state

        const doCompare = this.state.compare && !!this.props.surveyResponses2
        const summaryData2 = doCompare ? this.calculateData(surveyQuestion, this.props.surveyResponses2) : null
        const period1 = String(moment(filterData.from1).format('LL') + ' ~ ' + moment(filterData.to1).format('LL'))
        const period2 = String(moment(filterData.from2).format('LL') + ' ~ ' + moment(filterData.to2).format('LL'))
        const emailGroup = filterData.group.map(a => a.label).join(',');
        const section = filterData.section ? filterData.section.label : '';
        const question = filterData.question ? filterData.question.label : '';
        const answer = filterData.answer.map(a => a.label).join(',');

        rows.push([t('Filter options')])
        rows.push([
            t('Period1'),
            t('Emails Group'),
            t('Section'),
            t('Question'),
            t('Answers')
        ])
        rows.push([period1, emailGroup, section, question, answer])

        const summaryData = this.calculateData(surveyQuestion, surveyResponses)
        // Focus on the filter-selected section/question (same as screen/PDF).
        const focus = focusSelection(summaryData.reportSections, surveyQuestion, filterData)
        if (focus.focused) rows.push(['🔎 ' + t('Focused view'), focus.sectionTitle + (focus.questionTitle ? ' › ' + focus.questionTitle : '')])
        rows.push([t('Section Average with Rating')])
        if (doCompare) {
            rows.push([t('label'), 'A', 'B', 'Δ'])
            focus.sections.map((section, i) => {
                if (section.sectionScore === 0) return null
                const origIdx = focus.indices[i]
                const s2 = summaryData2.reportSections[origIdx]
                const a = section.sectionScore, b = s2 ? s2.sectionScore : 0
                rows.push([`Q.${origIdx}.${section.sectionTitle}`, a.toFixed(2), b.toFixed(2), (a - b >= 0 ? '+' : '') + (a - b).toFixed(2)])
            })
        } else {
            rows.push([t('label'), t('score')])
            focus.sections.map((section, i) => {
                if (section.sectionScore === 0) return null
                const sectionLabel = `Q.${focus.indices[i]}.${section.sectionTitle}`
                const sectionScore = `${t('Score:')}  ${section.sectionScore.toFixed(2)}`
                rows.push([sectionLabel, sectionScore])
            })
        }

        if(!reportData) {
            Toast(400, 'Error to generate CSV report');
        }
        let answerLabelValue = new Set();
        focus.sections.forEach(section => {
            section.reportQuestions.forEach(question => {
                question.reports.forEach(report => {
                    answerLabelValue.add(report.answerLabel);
                });
            });
        });
        const uniqueLabels = Array.from(answerLabelValue);
        rows.push([t('Question'), uniqueLabels.map(e => e), t('Score')])
        focus.sections.map(section => {
            if (section.sectionScore === 0) return null;


            section.reportQuestions.forEach((question, ekey) => {

                const questionTitle = question.questionTitle
                const questionScore = question.questionScore.toFixed(2)
                let questionrecord = [questionTitle];
                uniqueLabels && uniqueLabels.map((el) => {
                    const quest = question.reports.filter(q => q.answerLabel === el)[0];
                    const score = quest ? `${quest.count} (${quest.percent.toFixed(2)}) %` : '0 (0 %)'
                    questionrecord.push(score)
                })
                questionrecord.push(questionScore)
                rows.push(questionrecord)
            })

        });

        let csvContent = "data:text/csv;charset=utf-8,"
            + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        window.open(encodedUri);

    }

    // Excel export of the Summary view: a "Section averages" sheet (numeric scores) and a
    // "Questions with rating" matrix sheet (count (pct%) per bucket + numeric score).
    generateExcel = (fileName) => {
        const { reportData, reportData2 } = this.state
        const doCompare = this.state.compare && !!this.props.surveyResponses2 && reportData2
        // Focus on the filter-selected section/question (same as screen/PDF).
        const focus = focusSelection(reportData ? reportData.reportSections : [], this.props.surveyQuestion, this.props.filterData)
        const sections = focus.sections.filter(s => s.sectionScore > 0)

        let savg;
        if (doCompare) {
            savg = [[t('Section'), 'A', 'B', 'Δ']]
            focus.sections.forEach((s, i) => {
                if (s.sectionScore <= 0) return
                const s2 = reportData2.reportSections[focus.indices[i]]
                const a = s.sectionScore, b = s2 ? s2.sectionScore : 0
                savg.push([s.sectionTitle, Number(a.toFixed(2)), Number(b.toFixed(2)), Number((a - b).toFixed(2))])
            })
        } else {
            savg = [[t('Section'), t('Score')]]
            sections.forEach(s => savg.push([s.sectionTitle, Number(s.sectionScore.toFixed(2))]))
        }

        const labelSet = []
        sections.forEach(s => s.reportQuestions.forEach(q => q.reports.forEach(r => { if (labelSet.indexOf(r.answerLabel) < 0) labelSet.push(r.answerLabel) })))
        const matrix = [[t('Question')].concat(labelSet).concat([t('Score')])]
        sections.forEach(s => {
            matrix.push([s.sectionTitle].concat(labelSet.map(() => '')).concat([Number(s.sectionScore.toFixed(2))]))
            s.reportQuestions.forEach(q => {
                const row = [q.questionTitle]
                labelSet.forEach(l => { const b = q.reports.filter(x => x.answerLabel === l)[0]; row.push(b ? `${b.count} (${b.percent.toFixed(0)}%)` : '') })
                row.push(Number(q.questionScore.toFixed(2)))
                matrix.push(row)
            })
        })
        downloadXlsx([{ name: 'Section averages', rows: savg }, { name: 'Questions with rating', rows: matrix }], fileName)
    }

    // Columns for the matrix = the most common rating scale in the survey, ordered best→worst.
    // (Different-scale questions render as a spanning bar instead of into these columns.)
    matrixColumns = (sections) => {
        const sigCount = {}, sigCols = {}
        sections.forEach(s => s.reportQuestions.forEach(rq => {
            const b = ratingBuckets(rq.q, rq.reports)
            if (!b.rating || !b.buckets.length) return
            const ordered = b.buckets.slice().sort((a, c) => c.value - a.value) // best first
            const sig = ordered.map(x => x.label).join('|')
            sigCount[sig] = (sigCount[sig] || 0) + 1
            sigCols[sig] = ordered.map(x => ({ label: x.label, value: x.value }))
        }))
        let best = null, bestN = -1
        Object.keys(sigCount).forEach(sig => { if (sigCount[sig] > bestN) { bestN = sigCount[sig]; best = sig } })
        return best ? sigCols[best] : []
    }

    // Modern "questions with rating" matrix: count (pct%) per rating bucket + coloured score,
    // scale-aware, selected section/question surfaced first.
    renderQuestionMatrix = () => {
        const { reportData } = this.state
        const sections = this.orderedSections(reportData.reportSections).filter(s => s.sectionScore > 0)
        const cols = this.matrixColumns(sections)
        const colLabels = cols.map(c => c.label)

        const th = { padding: '9px 10px', textAlign: 'right', fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.04em', color: '#8a988f', fontWeight: 700, borderBottom: '1px solid #e2e8e4', whiteSpace: 'nowrap' }
        const thL = Object.assign({}, th, { textAlign: 'left' })
        const td = { padding: '8px 10px', textAlign: 'right', fontSize: 13, borderBottom: '1px solid #eef2f0', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }
        const tdL = Object.assign({}, td, { textAlign: 'left', whiteSpace: 'normal' })
        const scoreStyle = Object.assign({}, td, { fontWeight: 700, color: '#2f8a45' })

        const rows = []
        rows.push(<tr key="h">
            <th style={thL}>{t('Question')}</th>
            {cols.map(c => <th style={th} key={c.label}>{c.label}</th>)}
            <th style={Object.assign({}, th, { color: '#2f8a45' })}>{t('Score')}</th>
        </tr>)

        sections.forEach(section => {
            const sel = this.isSelectedSection(section)
            rows.push(<tr key={uuid()} style={{ background: sel ? '#eaf5ee' : '#f6f9f7' }}>
                <td style={Object.assign({}, tdL, { fontWeight: 700, borderLeft: sel ? '3px solid #2f9e44' : 'none' })}>{section.sectionTitle}{sel ? ' ★' : ''}</td>
                <td style={td} colSpan={cols.length}></td>
                <td style={scoreStyle}>{section.sectionScore.toFixed(2)}</td>
            </tr>)
            this.orderedQuestions(section).forEach(question => {
                const b = ratingBuckets(question.q, question.reports)
                const byLabel = {}
                b.buckets.forEach(x => { byLabel[x.label] = x })
                const aligned = colLabels.length > 0 && colLabels.every(l => byLabel[l] !== undefined) && b.buckets.length === colLabels.length
                rows.push(<tr key={uuid()}>
                    <td style={tdL}>{question.questionTitle}</td>
                    {aligned
                        ? cols.map(c => { const x = byLabel[c.label]; return <td style={td} key={c.label}>{x.count} ({Math.round(x.pct)}%)</td> })
                        : (b.buckets.length <= 3
                            // Few-option rating (e.g. Yes/No) doesn't fit the 5 rating columns —
                            // show its counts as inline "label: count (pct%)" text, consistent with
                            // the numeric rows, instead of a full-width bar.
                            ? <td style={Object.assign({}, td, { textAlign: 'left', whiteSpace: 'normal' })} colSpan={cols.length}>
                                {b.buckets.slice().sort((a, c) => c.value - a.value).map((x, i) => (
                                    <span key={i} style={{ marginRight: 18, whiteSpace: 'nowrap', display: 'inline-block' }}>
                                        <b style={{ color: '#1b2320' }}>{x.label}:</b> {x.count} ({Math.round(x.pct)}%)
                                    </span>
                                ))}
                            </td>
                            // Wide scales (e.g. 1–10) still render as a spanning distribution bar.
                            : <td style={Object.assign({}, td, { textAlign: 'left' })} colSpan={cols.length}><DistributionBar question={question.q} reports={question.reports} height={20} /></td>)}
                    <td style={scoreStyle}>{question.questionScore.toFixed(2)}</td>
                </tr>)
            })
        })

        return <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}><tbody>{rows}</tbody></table>
        </div>
    }

    render() {
        const { tab_index, reportData, compare } = this.state
        if (!reportData) return '...'
        const hasP2 = !!this.props.surveyResponses2
        const scale = this.overallScale(reportData)

        const subBtn = (idx, label) => {
            const active = tab_index === idx
            return <button onClick={() => this.setState({ tab_index: idx })} style={{
                border: '1px solid ' + (active ? '#2f9e44' : '#cfd8d3'), background: active ? '#2f9e44' : '#fff',
                color: active ? '#fff' : '#5d6d66', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 600,
                padding: '6px 12px', borderRadius: 8, cursor: 'pointer', marginRight: 6,
            }}>{label}</button>
        }

        return <div>
            {this.renderFocusBanner()}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: 14, marginBottom: 18 }}>
                <div style={{ background: '#fff', border: '1px solid #e2e8e4', borderRadius: 14, padding: '16px 18px', boxShadow: '0 1px 2px rgba(20,40,30,.06),0 6px 20px rgba(20,40,30,.05)' }}>
                    <div style={{ fontSize: 11.5, textTransform: 'uppercase', letterSpacing: '.08em', color: '#8a988f', fontWeight: 700 }}>{t('Overall score')}</div>
                    <div style={{ fontFamily: MONO, fontSize: 28, fontWeight: 700, marginTop: 6, color: '#1b2320' }}>{reportData.surveyScore.toFixed(2)}<span style={{ fontSize: 15, color: '#8a988f', fontWeight: 600 }}> / {scale}</span></div>
                    <div style={{ marginTop: 10 }}><Meter value={reportData.surveyScore} max={scale} height={7} /></div>
                </div>
            </div>

            <div style={{ background: '#fff', border: '1px solid #e2e8e4', borderRadius: 14, boxShadow: '0 1px 2px rgba(20,40,30,.06),0 6px 20px rgba(20,40,30,.05)', overflow: 'hidden' }}>
                <div style={{ padding: '14px 18px', borderBottom: '1px solid #e2e8e4', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                    <div>
                        {subBtn(0, t('Section Average with Rating'))}
                        {subBtn(1, t('Question with Rating'))}
                    </div>
                    {/* Compare periods applies to Section averages only — hidden on the matrix. */}
                    {tab_index === 0 && <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: hasP2 ? '#5d6d66' : '#b0bbb5', fontWeight: 600 }}>
                        <input type="checkbox" checked={compare} disabled={!hasP2} onChange={e => this.setState({ compare: e.target.checked })} />
                        {t('Compare periods')}
                        {!hasP2 && <span style={{ fontSize: 11, color: '#b0bbb5' }}>({t('set Period 2')})</span>}
                    </label>}
                </div>
                <div style={{ padding: '10px 18px 16px' }}>
                    {tab_index === 0 ? this.renderSectionAverages() : this.renderQuestionMatrix()}
                </div>
            </div>
        </div>;
    }
}
const mapStatsToProps = ({ user }) => ({ user });
export default connect(mapStatsToProps)(
    withTranslation()(withStyles(styles, { withTheme: true })(Analytical))
);